// extracted by mini-css-extract-plugin
export var modal = "_jm-0";